module.exports = "./img/3845ede930992f58d22eea97237125cb.png";